const designerInfo = {
    path: '/DesignManage/designerInfo',
    component: resolve => require(['@/views/DesignManage/designerInfo'], resolve),
    name: 'designerInfo',
    meta: {
        title: '设计师信息',
    }
};

const designerWorksInfo = {
    path: '/DesignManage/designerWorksInfo',
    component: resolve => require(['@/views/DesignManage/designerWorksInfo'], resolve),
    name: 'designerWorksInfo',
    meta: {
        title: '设计师作品信息',
    }
};



export default [designerInfo,designerWorksInfo]


// WEBPACK FOOTER //
// ./src/router/modules/designManage.js